import { DivColumn, DivRow, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import ConstantsImages from "../../../constants/ConstantsImages";
import UtilsUnit from "../../../utils/UtilsUnit";
import WidgetFixedSizeList from "../widget-fixed-size-list/WidgetFixedSizeList";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";
import "./WidgetUpdatesListGeneral.css";

const FEASIBILITY_COLUMN_KEYS = [
  "municipalityPosition",
  "municipalityPositionMeasure",
  "municipalityPositionMeasureChangeRequest",
  "approveFeasibilityChangeRequest",
  "rejectFeasibilityChangeRequest",
];

const YEAR_OF_NEED_COLUMN_KEYS = [
  "yearOfNeedGrade",
  "urgencyMeasure",
  "urgencyMeasureChangeRequest",
  "approveUrgencyChangeRequest",
  "rejectUrgencyChangeRequest",
];

const UPDATE_TITLE_BY_COLUMN = {
  urgencyMeasureChangeRequest: "בקשה לשינוי שנת צורך תחבורתי",
  approveUrgencyChangeRequest: "אישור בקשת שינוי שנת צורך תחבורתי",
  rejectUrgencyChangeRequest: "דחיית בקשת שינוי שנת צורך תחבורתי",
  municipalityPositionMeasureChangeRequest: "בקשה לשינוי עמדת הרשות המקומית ומורכבות התיאומים",
  approveFeasibilityChangeRequest: "אישור בקשת שינוי עמדת הרשות המקומית ומורכבות התיאומים",
  rejectFeasibilityChangeRequest: "דחיית בקשת שינוי עמדת הרשות המקומית ומורכבות התיאומים",
};

const WidgetUpdatesListGeneral = ({ data, urgencyMeasure = [] }) => {
  const items = Array.isArray(data) ? data : [];

  const Row = ({ index, style }) => {
    const dataItem = items[index];
    return (
      <div key={index} style={{ ...style, overflowX: "hidden", maxWidth: "100%" }}>
        <UpdatesItemUI dataItem={dataItem} />
      </div>
    );
  };

  return (
    <DivColumn className="ulg-frame">
      <DivRow className="ulg-header">
        <ParagraphText className="ulg-title">{ConstantsTexts.CODE_28}</ParagraphText>
      </DivRow>
      <div className="ulg-list">
        <WidgetFixedSizeList height={29} itemCount={items.length} itemSize={15.3} style={{ overflowX: "hidden" }}>
          {Row}
        </WidgetFixedSizeList>
      </div>
    </DivColumn>
  );

  function UpdatesItemUI({ dataItem }) {
    const valueBefore = formatUpdateValue(dataItem, dataItem?.valueBefore, urgencyMeasure);
    const valueAfter = formatUpdateValue(dataItem, dataItem?.valueAfter, urgencyMeasure);
    const hasValueChips = valueBefore !== "" && valueAfter !== "";
    const actionTitle = getUpdateActionTitle(dataItem);

    return (
      <DivColumn className="ulg-item">
        <DivColumn className="ulg-meta">
          <DivRow className="ulg-meta-row">
            <ParagraphText className="ulg-time">{UtilsUnit.formatDateHour(dataItem.changeTimeStamp)}</ParagraphText>
            <ParagraphText className="ulg-date">{UtilsUnit.formatDate(dataItem.changeTimeStamp)}</ParagraphText>
            <div className="ulg-icon">
              <WidgetIconFive iconProp={ConstantsImages.UPDATES_LIST_DATE_IMAGE} widthIconProp="1.9rem" heightIconProp="1.35rem" />
            </div>
          </DivRow>
          <DivRow className="ulg-meta-row ulg-meta-row-user">
            <ParagraphText className="ulg-user">{dataItem.userName}</ParagraphText>
            <div className="ulg-icon">
              <WidgetIconFive iconProp={ConstantsImages.UPDATES_LIST_PERSON_IMAGE} widthIconProp="1.9rem" heightIconProp="1.25rem" />
            </div>
          </DivRow>
        </DivColumn>

        {actionTitle && (
          <DivRow className="ulg-action-row">
            <ParagraphText className="ulg-action">{actionTitle}</ParagraphText>
            <div className="ulg-icon">
              <WidgetIconFive iconProp={ConstantsImages.UPDATES_LIST_COLUMN_IMAGE} widthIconProp="1.76rem" heightIconProp="1.05rem" />
            </div>
          </DivRow>
        )}

        {hasValueChips && (
          <DivRow className="ulg-chips">
            <div className="ulg-chip ulg-chip-after">
              <ParagraphText className="ulg-chip-after-text">{valueAfter}</ParagraphText>
            </div>
            <div className="ulg-chips-arrow">
              <WidgetIconFive iconProp={ConstantsImages.UPDATES_LIST_ARROW_IMAGE} widthIconProp="1.8rem" heightIconProp="0.6rem" />
            </div>
            <div className="ulg-chip ulg-chip-before">
              <ParagraphText className="ulg-chip-before-text">{valueBefore}</ParagraphText>
            </div>
          </DivRow>
        )}
      </DivColumn>
    );
  }
};

function getUpdateActionTitle(dataItem) {
  const columnName = dataItem?.changedColumnName || "";
  const mappedTitle = UPDATE_TITLE_BY_COLUMN[columnName];
  if (mappedTitle) {
    return mappedTitle;
  }

  const hebrewTitle = String(dataItem?.changedColumnNameHebrew || "").trim();
  if (!hebrewTitle) {
    return "";
  }

  if (hebrewTitle === "בקשה לשינוי שנת צורך" || hebrewTitle === "בקשה לשינוי שנת צורך תחבורה") {
    return "בקשה לשינוי שנת צורך תחבורתי";
  }

  if (hebrewTitle === "אישור בקשת שינוי שנת צורך" || hebrewTitle === "אישור בקשת שינוי שנת צורך תחבורה") {
    return "אישור בקשת שינוי שנת צורך תחבורתי";
  }

  if (hebrewTitle === "דחיית בקשת שינוי שנת צורך" || hebrewTitle === "דחיית בקשת שינוי שנת צורך תחבורה") {
    return "דחיית בקשת שינוי שנת צורך תחבורתי";
  }

  return hebrewTitle;
}

function isYearOfNeedUpdate(dataItem) {
  const columnName = dataItem?.changedColumnName || "";
  const columnHebrew = dataItem?.changedColumnNameHebrew || "";

  return (
    YEAR_OF_NEED_COLUMN_KEYS.some((key) => columnName === key || columnName.includes(key)) ||
    columnHebrew.includes("שנת צורך")
  );
}

function isFeasibilityUpdate(dataItem) {
  const columnName = dataItem?.changedColumnName || "";
  const columnHebrew = dataItem?.changedColumnNameHebrew || "";

  return (
    FEASIBILITY_COLUMN_KEYS.some((key) => columnName === key || columnName.includes(key)) ||
    columnHebrew.includes("עמדת הרשות") ||
    columnHebrew.includes("ישימות")
  );
}

function formatYearOfNeedLabel(value) {
  const str = String(value ?? "").trim();
  if (!str) {
    return "";
  }

  if (str.includes("שנת")) {
    return str;
  }

  const untilYearMatch = str.match(/^עד\s*(\d{4})$/);
  if (untilYearMatch) {
    return `עד שנת ${untilYearMatch[1]}`;
  }

  if (/^\d{4}$/.test(str)) {
    return `עד שנת ${str}`;
  }

  return str;
}

function formatUpdateValue(dataItem, rawValue, urgencyMeasure = []) {
  if (rawValue == null || rawValue === "") {
    return "";
  }

  if (isYearOfNeedUpdate(dataItem)) {
    const str = String(rawValue).trim();
    const numeric = Number(str);

    if (Number.isInteger(numeric) && numeric >= 1 && numeric <= 5) {
      const measure = urgencyMeasure.find((item) => Number(item.urgencyMeasureGrade) === numeric);
      if (measure?.urgencyMeasureValue) {
        return formatYearOfNeedLabel(measure.urgencyMeasureValue);
      }
    }

    return formatYearOfNeedLabel(str);
  }

  if (isFeasibilityUpdate(dataItem)) {
    const numeric = Number(rawValue);
    if (!Number.isFinite(numeric) || numeric < 1 || numeric > 5) {
      return String(rawValue);
    }

    return UtilsUnit.getGaugeNumberText(numeric);
  }

  return String(rawValue);
}

export default WidgetUpdatesListGeneral;
